export const AUTH_FEATURE_KEY = "auth";
